import { getStorageValue } from 'App/Helpers/localStorageHandler';

const isBrowserSupportPWA = () => {
    const userAgent = navigator.userAgent;
    const isSamsungBrowser = userAgent.includes('SamsungBrowser');
    const isFirefox =
        userAgent.includes('Firefox') && !userAgent.includes('Seamonkey');
    const isOpera = userAgent.includes('Opera') || userAgent.includes('OPR');
    const isSafari =
        userAgent.includes('Safari') && !userAgent.includes('Chrome');

    return !isSamsungBrowser && !isFirefox && !isOpera && !isSafari;
};

export function getPwaDimension(pwaStatus) {
    if (pwaStatus === 'Installed') {
        return 'pwa_installed';
    }
    if (pwaStatus === 'NotInstalled') {
        return 'pwa_not_installed';
    }
    if (pwaStatus === 'NotSupported') {
        return 'pwa_not_supported';
    }

    return undefined;
}

/**
 * Checks if app is installable as pwa
 *
 * return boolean
 */
export const isPwaInstallable = () => {
    return window.BeforeInstallPromptEvent && isBrowserSupportPWA();
};

/**
 * Checks if show pwa phase
 *
 * @param {string} storageKey  -The base key/namespace used by storage helpers.
 * @return boolean
 */
export const canShowPwaPhase = (storageKey) => {
    const storagePwaPhaseValue = getStorageValue(storageKey, 'pwa.showPhase');
    const showPwaPhase = storagePwaPhaseValue !== false;
    const isInstallable = isPwaInstallable();

    return isInstallable && showPwaPhase;
};

/**
 * Checks if an app is installed as PWA
 *
 * @param {string} storageKey  -The base key/namespace used by storage helpers.
 * @return {'Installed' | 'NotInstalled' | 'NotSupported'}
 */
export const getPWAState = (storageKey) => {
    if (
        getStorageValue(storageKey, 'pwa.status') === 'Installed' ||
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone
    ) {
        return 'Installed';
    } else if (!isPwaInstallable()) {
        return 'NotSupported';
    } else {
        return 'NotInstalled';
    }
};
